import enTranslations from '../locales/en.json';
import ruTranslations from '../locales/ru.json';
import kkTranslations from '../locales/kk.json';

const translations = {
  en: enTranslations,
  ru: ruTranslations,
  kk: kkTranslations,
};

export type Language = keyof typeof translations;

const LANGUAGE_COOKIE_NAME = 'preferred-language';

export function setCookie(name: string, value: string, days: number = 365) {
  if (typeof window === 'undefined') return;

  const expires = new Date();
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);

  // Detect HTTPS at runtime for secure cookie transmission
  const isSecure = typeof window !== 'undefined' && window.location.protocol === 'https:';
  const secureFlag = isSecure ? ' Secure;' : '';

  document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/;SameSite=Lax;${secureFlag}`;
}

export function getCookie(name: string): string | null {
  if (typeof window === 'undefined') return null;
  
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop()?.split(';').shift() || null;
  return null;
}

export function saveLanguageToCache(language: string) {
  setCookie(LANGUAGE_COOKIE_NAME, language);
}

export function getLanguageFromCache(): string | null {
  return getCookie(LANGUAGE_COOKIE_NAME);
}

export function getBrowserLanguage(): string {
  if (typeof window === 'undefined') return 'en';

  const supportedLanguages: Language[] = ['en', 'ru', 'kk'];
  const browserLang = navigator.language.split('-')[0]; // Get language code without region (e.g., 'en' from 'en-US')

  // Check if browser language is supported
  if (supportedLanguages.includes(browserLang as Language)) {
    return browserLang;
  }

  // Default to English if not supported
  return 'en';
}

export function getTranslations(lang: string = 'en') {
  const language = (lang as Language) || 'en';
  return translations[language] || translations.en;
}